import React from "react";

const SideBarCollapse = (props) =>
	(<div className="sidebar-collapse" id="sidebar-collapse">
		<i className="collapse-icon fa fa-bars"></i>
	</div>);

export default SideBarCollapse;



/** WEBPACK FOOTER **
 ** ./src/scripts/components/header/SideBarCollapse.jsx
 **/